import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { breakpoints } from 'theme';

export const BreadcrumbNav = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.baliHai};
  margin-bottom: 24px;
  min-width: 0;
  word-break: break-word;

  @media ${breakpoints.downSmPlus} {
    font-size: 12px;
    margin-bottom: 16px;
    gap: 6px;
  }
`;

export const BreadcrumbLink = styled(Link)`
  color: ${({ theme }) => theme.color.baliHai};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const BreadcrumbSeparator = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const BreadcrumbCurrent = styled.span`
  color: ${({ theme }) => theme.color.BlueBayoux};
  font-weight: 700;
`;
